import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useBiopharmaGroupsState() {
  return useAppState();
}

export function useBiopharmaGroupsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      filterOptionsModalIsOpen: false,
      searchModalIsOpen: false,
      categoryModalIsOpen: false,
      stateModalIsOpen: false,
      countryModalIsOpen: false,
      municipalityModalIsOpen: false,
      pageNumber: null,
      numberOfPages: 1,
      biopharmaGroups: [],
      filterOptions: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function openFilterOptionsModal() {
    dispatch((appState) => ({
      ...appState,
      filterOptionsModalIsOpen: true,
    }));
  }

  function closeFilterOptionsModal() {
    dispatch((appState) => ({
      ...appState,
      filterOptionsModalIsOpen: false,
    }));
  }

  function openSearchModal() {
    dispatch((appState) => ({
      ...appState,
      searchModalIsOpen: true,
    }));
  }

  function closeSearchModal() {
    dispatch((appState) => ({
      ...appState,
      searchModalIsOpen: false,
    }));
  }

  function openCategoryModal() {
    dispatch((appState) => ({
      ...appState,
      categoryModalIsOpen: true,
    }));
  }

  function closeCategoryModal() {
    dispatch((appState) => ({
      ...appState,
      categoryModalIsOpen: false,
    }));
  }

  function openStateModal() {
    dispatch((appState) => ({
      ...appState,
      stateModalIsOpen: true,
    }));
  }

  function closeStateModal() {
    dispatch((appState) => ({
      ...appState,
      stateModalIsOpen: false,
    }));
  }

  function openCountryModal() {
    dispatch((appState) => ({
      ...appState,
      countryModalIsOpen: true,
    }));
  }

  function closeCountryModal() {
    dispatch((appState) => ({
      ...appState,
      countryModalIsOpen: false,
    }));
  }

  function openMunicipalityModal() {
    dispatch((appState) => ({
      ...appState,
      municipalityModalIsOpen: true,
    }));
  }

  function closeMunicipalityModal() {
    dispatch((appState) => ({
      ...appState,
      municipalityModalIsOpen: false,
    }));
  }

  function updateFuzzySearchName(fuzzySearchName) {
    dispatch((appState) => ({
      ...appState,
      filterOptions: {
        ...appState.filterOptions,
        fuzzy_search_name: fuzzySearchName,
      }
    }));
  }

  function selectAllCategories() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.categories) {
        for (let key in newState.filterOptions.categories) {
          if (newState.filterOptions.categories.hasOwnProperty(key)) {
            newState.filterOptions.categories[key] = true;
          }
        }
      }
      return newState;
    });
  }

  function deselectAllCategories() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.categories) {
        for (let key in newState.filterOptions.categories) {
          if (newState.filterOptions.categories.hasOwnProperty(key)) {
            newState.filterOptions.categories[key] = false;
          }
        }
      }
      return newState;
    });
  }

  function selectAllCountries() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.countries) {
        for (let key in newState.filterOptions.countries) {
          if (newState.filterOptions.countries.hasOwnProperty(key)) {
            newState.filterOptions.countries[key] = true;
          }
        }
      }
      return newState;
    });
  }

  function deselectAllCountries() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.countries) {
        for (let key in newState.filterOptions.countries) {
          if (newState.filterOptions.countries.hasOwnProperty(key)) {
            newState.filterOptions.countries[key] = false;
          }
        }
      }
      return newState;
    });
  }

  function selectAllStates() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.states) {
        for (let key in newState.filterOptions.states) {
          if (newState.filterOptions.states.hasOwnProperty(key)) {
            newState.filterOptions.states[key] = true;
          }
        }
      }
      return newState;
    });
  }

  function deselectAllStates() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.states) {
        for (let key in newState.filterOptions.states) {
          if (newState.filterOptions.states.hasOwnProperty(key)) {
            newState.filterOptions.states[key] = false;
          }
        }
      }
      return newState;
    });
  }

  function selectAllMunicipalities() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.municipalities) {
        for (let key in newState.filterOptions.municipalities) {
          if (newState.filterOptions.municipalities.hasOwnProperty(key)) {
            newState.filterOptions.municipalities[key] = true;
          }
        }
      }
      return newState;
    });
  }

  function deselectAllMunicipalities() {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.municipalities) {
        for (let key in newState.filterOptions.municipalities) {
          if (newState.filterOptions.municipalities.hasOwnProperty(key)) {
            newState.filterOptions.municipalities[key] = false;
          }
        }
      }
      return newState;
    });
  }

  function toggleStateFilterOption(state) {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.states) {
        newState.filterOptions.states[state] = !newState.filterOptions.states[state];
      }
      return newState;
    });
  }

  function toggleCountryFilterOption(country) {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.countries) {
        newState.filterOptions.countries[country] = !newState.filterOptions.countries[country];
      }
      return newState;
    });
  }

  function toggleMunicipalityFilterOption(municipality) {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.municipalities) {
        newState.filterOptions.municipalities[municipality] = !newState.filterOptions.municipalities[municipality];
      }
      return newState;
    });
  }

  function toggleCategoryFilterOption(category) {
    dispatch((appState) => {
      const newState = { ...appState };
      if (newState.filterOptions?.categories) {
        newState.filterOptions.categories[category] = !newState.filterOptions.categories[category];
      }
      return newState;
    });
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    openFilterOptionsModal,
    closeFilterOptionsModal,
    openSearchModal,
    closeSearchModal,
    openCategoryModal,
    closeCategoryModal,
    openStateModal,
    closeStateModal,
    openCountryModal,
    closeCountryModal,
    openMunicipalityModal,
    closeMunicipalityModal,
    updateFuzzySearchName,
    selectAllCategories,
    deselectAllCategories,
    selectAllCountries,
    deselectAllCountries,
    selectAllStates,
    deselectAllStates,
    selectAllMunicipalities,
    deselectAllMunicipalities,
    toggleStateFilterOption,
    toggleCountryFilterOption,
    toggleMunicipalityFilterOption,
    toggleCategoryFilterOption,
    clearFeedback,
  };
}
